import { MsgExecuteContract } from "cosmes/client"
import { useWallet } from "providers/WalletProvider"
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { FACTORY_ADDRESS } from "utils/Constants"
import { querySmartContract } from "utils/RpcHelper"

export function SubscribesPage() {
    const { chatId } = useParams()
    const { address: walletAddress, post } = useWallet()
    const [tokenFee, setTokenFee] = useState<string>()
    const [availableFee, setAvailableFee] = useState<{ [key: string]: number }>({})
    const [feeInfos, setFeeInfos] = useState<{ [key: string]: { symbol: string } }>({})
    const navigate = useNavigate()

    const loadConfig = async () => {
        try {
            const { subscribe_fee } = await querySmartContract(FACTORY_ADDRESS, { config: {} })
            for (const key of Object.keys(subscribe_fee)) {
                const { symbol } = await querySmartContract(key, { token_info: {} })
                setFeeInfos(prev => ({ ...prev, [key]: { symbol: symbol } }))
            }
            setAvailableFee(Object.entries(subscribe_fee).reduce((prev, [key, value]) => ({ ...prev, [key]: Number(value) }), {}))
        } catch {
        }
    }

    useEffect(() => {
        loadConfig()
    }, [])

    const subscribes = async () => {
        if (!walletAddress) return alert("Please connect your wallet first")
        if (!tokenFee) return alert("Please select fee option")

        try {
            const subscribeMsg = {
                subscribe: {
                    chat_id: chatId
                }
            };

            let msg = undefined;
            const { total_subscriber, is_subscribed } = await querySmartContract(FACTORY_ADDRESS, { check_subscription: { chat_id: chatId } })
            if (is_subscribed == true) return alert("You are already subcribed for trade notifications")

            if ((total_subscriber ?? 0) > 50) {
                const fee = availableFee[tokenFee]
                const { balance } = await querySmartContract(tokenFee, { balance: { address: walletAddress } })
                if ((!balance || !fee) || balance < fee) return alert("Your balance is not enough to pay the fee")

                msg = new MsgExecuteContract({
                    sender: walletAddress,
                    contract: tokenFee,
                    funds: [],
                    msg: {
                        send: {
                            msg: Buffer.from(JSON.stringify(subscribeMsg)).toString("base64"),
                            contract: FACTORY_ADDRESS,
                            amount: fee.toString()
                        }
                    },
                })
            } else {
                alert("Congratulation, your subcription is free")
                msg = new MsgExecuteContract({
                    sender: walletAddress,
                    contract: FACTORY_ADDRESS,
                    funds: [],
                    msg: subscribeMsg,
                })
            }


            const txHash = await post({
                msgs: [msg],
                memo: `Subscribe`
            }, [])

            navigate("/tx-loading/" + txHash)
        } catch (e) {
            console.log(e)
            alert("error: " + e + ", (PLEASE REPORT TO DEVELOPER)")
        }

    }

    return <div className="w-100 p-2 px-4">
        <>
            <h4>Subscribe to a trade</h4>
            <p className="text-muted">Subscribe a pair to listen for every trade event</p>
        </>

        {
            Object.entries(availableFee).length > 0 && <div className="form-group">
                <label htmlFor="fee">Fee</label>
                <select
                    onChange={({ target }) => setTokenFee(target.value)}
                    className="form-control"
                    id="pair-address">
                    <option>Select Fee</option>
                    {
                        Object.entries(availableFee).map(([address, amount]) => <option value={address}>{amount / 1e6} {feeInfos[address]?.symbol}</option>)
                    }
                </select>
            </div>
        }



        <button type="button" onClick={subscribes} className="btn btn-primary w-100 btn-lg">Subscribe</button>

    </div>
}